// ------------------------------------
// props 輸入需求 :
// props.setNavIndex : function( params : str )        ( 回傳 : str (回傳選到的分頁名稱) )
// ------------------------------------

import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import common_images from '../../comm_imgs'
import { resources } from '../../i18n';
import './_navBarMobile.scss';
import dh_alert from '../../actions/dataHandler_alert';
import Mos from '../../actions/Mos';
import { useDispatch, useSelector } from 'react-redux';
import dataHandler_alert from '../../actions/dataHandler_alert';
import ApiGo from '../../actions/ApiGo';
import { ADD_ALERTS_ARRAY, ADD_ALERTS_ARRAY_RESIDENT } from '../../stores/reducer_alerts';
import { LogTime } from '../../actions/forFrontEnd_Log';
import AlertCancel from '../popUp/AlertCancel';
import ConfigHandler from '../../actions/ConfigHandler';
import LogoutBtnMobile from '../Login/LogoutBtnMobile';
import { NavBarTabMobile } from './NavbarTabMobile';
import NotificationBar from './NotifictionBar';

export const NavBarMobile = (props) => {
    const ACCOUNT_NAME = () => localStorage.getItem("currentUser") || sessionStorage.getItem("currentUser")

    // 登出組合
    const [logoutBtn, setLogoutBtn] = useState(false);
    function toggleLogoutBtn() { setLogoutBtn(!logoutBtn) }

    // ------ 從 redux 拿 resident row ------------------
    const store_resident_array = useSelector(state => state.store_residents.orign_residents_array)
    const store_beds_array = useSelector(state => state.store_beds.beds_array)
    // ------ 從 redux 拿 resident row ------------------

    // i18n 組合
    const { t, i18n } = useTranslation(); // 1.2 i18n
    const lng_choice = Object.entries(resources).map(res => res[1].title)
    lng_choice.unshift(t('GLOBAL.CHANGE_LANGUAGE'))
    const DP_data = { keys: lng_choice }
    const [returnLng, setReturnLng] = useState("");     //dropdown return result
    // language 存為預設
    function storeLanguageToStorage(lng) {
        localStorage.setItem("i18nextLng", lng)
        sessionStorage.setItem("i18nextLng", lng)
    }
    // language 修改
    useEffect(() => {
        let result = Object.entries(resources).filter(res => res[1].title === returnLng)[0]
        if (result !== undefined) {
            storeLanguageToStorage(result[0])
            i18n.changeLanguage(result[0])
        }
    }, [returnLng, i18n])
    // 換語言按鈕 新版 (非dropdown)
    const [dashboardDevice, setDashboardDevice] = useState(false);
    function toggleDD() {
        setDashboardDevice(!dashboardDevice)
        props.setNavIndex(dashboardDevice);
    }

    // ----------- Notify 組合 --------------------------
    const [notify, setNotify] = useState(false);
    function toggleNotify() { setNotify(!notify) }
    const mos = Mos()
    const mos_events = mos.events;
    const mos_diaper = mos.diaper;
    // const [mos_moteckAR, setMos_moteckAR] = useState(false);
    // const mos_moteckAR = mos.moteckAlertReply;
    const mos_rr = (ConfigHandler.isShowCF()) ? mos.rr : mos.CFBreath;
    const mos_hr = (ConfigHandler.isShowCF()) ? 2 : mos.CFHeartBeat;
    const [alertSpeakCount, setAlertSpeakCount] = useState(1);
    const store_alerts = useSelector(state => state.store_alerts.alert_array)
    const [menuPop, setMenuPop] = useState(0);
    function toggleMP() { setMenuPop(!menuPop) }
    const [alertCancel, setAlertCancel] = useState({
        cancel: false,
        resident: 0
    });
    function toggleAlertCancel(res) {
        setAlertCancel({
            cancel: !alertCancel.cancel,
            resident: res
        })
        setNotify(false)
    }
    const store_resident_withAlerts = useSelector(state => state.store_alerts.residents_with_alerts)
    function identifyAlert(store = [], id = "", cancel, alerts) {
        let _index = store.indexOf(id)
        if (!cancel) { return { open: false, content: {} } }
        if (_index === -1) { return { open: false, content: {} } }
        let _a = alerts.filter(res => res.resident_id === id)
        return { open: true, content: _a }
    }
    const dispatch = useDispatch()
    async function getAlert() {
        let [alert, vital, diaper, resident_arr, unResolved] = [{}, [], [], [], []]
        try {
            vital = await ApiGo.getAll_resident_vital_abnormal(new LogTime().getDate(), "ALL")
            let _temp = vital.filter(res => res.resolved === null)
            unResolved = [..._temp, ...unResolved]
        }
        catch { }
        try {
            alert = await ApiGo.getAll_resident_bed_state_alerts(new LogTime().getDate(), "ALL")
            let _temp = alert.alerts.filter(res => res.resolved === null)
            unResolved = [..._temp, ...unResolved]
        }
        catch { }
        try {
            // diaper = await ApiGo.get_diaper_history_abnormal(new LogTime().getDate(), "ALL")
            // let _temp = diaper.filter(res=>res.resolved===null)
            // unResolved = [..._temp, ...unResolved]
        }
        catch { }
        dispatch(ADD_ALERTS_ARRAY(unResolved))
        unResolved.forEach(res => {
            let resident = store_resident_array.filter(store => store.id === res.resident_id)[0]
            if (resident_arr.indexOf(resident.id) === -1) { resident_arr.push(resident.id) }
        })
        dispatch(ADD_ALERTS_ARRAY_RESIDENT(resident_arr))
    }

    useEffect(() => {
        ApiGo.getAlert_speak_count()
            .then(res => {
                let _time = res.split(" ")[1]
                let _speed = res.split(" ")[3]

                setAlertSpeakCount({
                    timeCount: parseInt(_time[0]),
                    speed: parseInt(_speed)
                })
            })
            .catch(() => { })
        if (store_resident_array.length === 0) { return }
        getAlert()
    }, [store_resident_array])

    useEffect(() => {
        if (mos_events === null) { return }
        if (dh_alert(mos_events.alert_level, mos_events.bed_state) === "No such information") { return }
        let _bed_info = store_beds_array.filter(bed => bed.id === mos_events.bed_id)[0] || []
        let _resident = store_resident_array.filter(resid => resid.id === _bed_info.resident_id)[0] || null
        if (_resident === null) { return }
        if (dh_alert(mos_events.alert_level, mos_events.bed_state).level === "emergency") {
            let _txt = _resident.first_name + _resident.last_name + t(dataHandler_alert(mos_events.alert_level, mos_events.bed_state).msg)
            speak(_txt);
        }
        getAlert()
    }, [mos_events]);

    useEffect(() => {
        if (!ConfigHandler.isShowAIDC()) { return }
        if (mos_diaper !== null) { handlingDiaperFilter() }
        function handlingDiaperFilter() {
            if (mos_diaper === null) return
            let _diaper_alert_txt = ''
            if (mos_diaper !== "resolved") {
                if (mos_diaper.angle_abnormal === 0
                    && mos_diaper.water_not_enough === 0
                    && mos_diaper.sewage_volume === 0
                    && mos_diaper.poop_bowl_abnormal === 0
                ) return
                if (mos_diaper.angle_abnormal === 1) _diaper_alert_txt += t("DIAPER.ANGLE_ABNORMAL")
                if (mos_diaper.water_not_enough === 1) _diaper_alert_txt += t("DIAPER.WATER_NOT_ENOUGH")
                if (mos_diaper.sewage_volume === 1) _diaper_alert_txt += t("DIAPER.SEWAGE_VOLUME")
                if (mos_diaper.poop_bowl_abnormal === 1) _diaper_alert_txt += "電子尿布系統異常，請查看系統面板。"
            }
            let _bed_info = store_beds_array.filter(bed => bed.id === parseInt(mos_diaper.bed_id))[0] || []
            let _resident = store_resident_array.filter(resid => resid.id === _bed_info.resident_id)[0] || null
            if (mos_diaper !== "resolved") {
                if (_resident === null) return
                let _txt = _resident.first_name + _resident.last_name + t("GLOBAL.BED_STATE.DIAPER") + _diaper_alert_txt
                speak(_txt);
            }
            getAlert()
        }
    }, [mos_diaper]);


    useEffect(() => {
        if (!ConfigHandler.isShowCF()) { return }
        if (mos_rr !== null) { handlingAlertFilter() }
        function handlingAlertFilter() {
            if (mos_rr === null) { return }
            let _bed_info = store_beds_array.filter(bed => bed.mac === mos_rr.mac)[0] || []
            let _resident = store_resident_array.filter(resid => resid.id === _bed_info.resident_id)[0] || null
            if (_resident === null) { return }
            if (mos_rr.value <= _resident.breath_high && mos_rr.value >= _resident.breath_low) { return }
            let status = ""
            if (mos_rr.value > _resident.breath_high) { status = "呼吸過快" }
            if (mos_rr.value < _resident.breath_low) { status = "呼吸過慢" }
            let _txt = _resident.first_name + _resident.last_name + status
            speak(_txt);
        }
    }, [mos_rr]);

    useEffect(() => {
        if (!ConfigHandler.isShowCF()) { return }
        if (mos_hr !== null) { handlingAlertFilter() }
        function handlingAlertFilter() {
            if (mos_hr === null) { return }
            let _bed_info = store_beds_array.filter(bed => bed.mac === mos_hr.mac)[0] || []
            let _resident = store_resident_array.filter(resid => resid.id === _bed_info.resident_id)[0] || null
            if (_resident === null) { return }
            if (mos_hr.value <= _resident.heart_high && mos_hr.value >= _resident.heart_low) { return }
            let status = ""
            if (mos_hr.value > _resident.heart_high) { status = "心跳過快" }
            if (mos_hr.value < _resident.heart_low) { status = "心跳過慢" }
            let _txt = _resident.first_name + _resident.last_name + status
            speak(_txt);
        }
    }, [mos_hr]);

    function speak(msg) {
        let u = new SpeechSynthesisUtterance();
        u.lang = i18n.language;
        u.text = msg;
        u.rate = alertSpeakCount.speed;
        for (let i = 0; i < alertSpeakCount.timeCount; i++) {
            speechSynthesis.speak(u);
        }
    }
    function speakStart(msg) {
        let u = new SpeechSynthesisUtterance();
        u.lang = i18n.language;
        u.text = msg;
        u.rate = alertSpeakCount.speed;
        speechSynthesis.speak(u);
    }
    // ----------- Notify 組合 --------------------------
    const LayoutPage = useSelector(state => state.store_layout)
    return (
        <div className="container-fluid">
            {identifyAlert(store_resident_withAlerts, alertCancel.resident.id, alertCancel.cancel, store_alerts).open ?
                <AlertCancel
                    hide={toggleAlertCancel}
                    content={identifyAlert(store_resident_withAlerts, alertCancel.resident.id, alertCancel.cancel, store_alerts).content}
                    resident={alertCancel.resident}
                />
                : null}
            <NavBarTabMobile show={menuPop} />
            <div className="row navBarMobile">
                <div className="w-100 disp font-ml cancel-pad">
                    <div className='fx-d-r fx-ccc'>
                        <div className={`Hamburger ${menuPop ? 'barFrameClick' : 'barFrame'}`} onClick={toggleMP}>
                            <div className='nhambar'></div>
                        </div>
                        <div className="fx-d-c fx-fsc MWG w-100" onClick={toggleNotify}>
                            <div className="fontMWG">MWG</div>
                            <div className={`w-100`}>
                                <div className="font-m fx-d-r fx-ccc w-100">
                                    {t("GLOBAL.NOTIFICATION")}
                                    <div className="notf_count fx-ccc br-10 mar-5 b">{store_alerts.length}</div>
                                </div>
                                {notify ? <NotificationBar toggleAlertCancel={toggleAlertCancel} /> : null}
                            </div>
                        </div>
                    </div>
                    <div className='fx-d-r fx-ccc'>
                        <div className='font-m w-50 h-100 fx-ccc'>
                            <div className='w-100 fx-cspbt'>
                                <div onClick={() => { speakStart("語音開啟") }}
                                    className='w-100 h-100 speaker fx-d-c cursor-pointer shadow-xs'>
                                    <div>開啟</div>
                                    <div>語音</div>
                                </div>
                            </div>
                        </div>
                        <div className="fx-d-c " onClick={toggleDD}>
                            <div className="fx-d-c fx-ccc navM-option">
                                <img src={ConfigHandler.layoutControl().layoutArr[LayoutPage.currentPage][0]} className="pic" alt="i18n" />
                                <div>{t(ConfigHandler.layoutControl().layoutArr[LayoutPage.currentPage][1])}</div>
                            </div>
                        </div>
                        <div className="fx-d-c" onClick={toggleLogoutBtn}>
                            <div className={`fx-d-c fx-ccc navM-option logout ${(logoutBtn) ? "activate" : ""}`}>
                                <img src={common_images.USER} className="pic" alt="logout" />
                                <div>{ACCOUNT_NAME()}</div>
                            </div>
                            <div>
                                {logoutBtn ? <LogoutBtnMobile hide={toggleLogoutBtn} /> : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
